import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { EntitlementService } from '../../services/entitlement.service';
import { ShipService } from '../../services/ship.service';
import { Ship } from '../../Ship';
import { ProfileSearchResult } from '../../data/ProfileSearchResult';
import { CardholderService } from '../../services/cardholder.service';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  searchResults: ProfileSearchResult[];
  subview = '';
  search_btn = false;
  ships: string[];
  newSearchTerm = '';
  searchTerm = '';
  processing = false;
  firstParameter = '';
  selectedLocation = '';
  search_btn_spinner = '';
  cardholdersSearchForm: UntypedFormGroup;

  constructor(
    private entitlementService: EntitlementService,
    private shipService: ShipService,
    private cardHolderService: CardholderService,
    private router: Router
  ) {}

  ngOnInit() {
    this.initForm();
    this.searchResults = CardholderService.retrieveAllCardholderResults();
    if (this.searchResults.length > 0) {
      this.subview = 'recentResults';
    }

    this.processing = true;
    this.shipService.getShips().subscribe(
      (data: Ship[]) => {
        // const someships = data;
        this.ships = data.map(ship => {
          return ship.shipName;
        });
      },
      () => {
        console.log('There was an error fetching ship information.');
      },
      () => {
        this.processing = false;
        const searchTuple = this.cardHolderService.getPendingSearch();
        if (searchTuple != null) {
          this.selectedLocation = searchTuple[0];
          this.firstParameter = searchTuple[1];
          this.submit();
        }
      }
    );
  }

  initForm() {
    this.cardholdersSearchForm = new UntypedFormGroup({
      firstParameter: new UntypedFormControl('', {
        validators: [Validators.minLength(2)],
        updateOn: 'change'
      })
    });

    this.onChange();
  }

  onChange() {
    this.cardholdersSearchForm
      .get('firstParameter')
      .valueChanges.subscribe((search: string) => {
        this.firstParameter = search;
        this.cardholdersSearchForm.controls['firstParameter'].markAsTouched();
      });
  }

  onSearchEnter(event: any) {
    if (event.value) {
      this.selectedLocation = event.value;
    }
  }

  selectLocation(location: any) {
    if (location && location.value) {
      this.selectedLocation = location.value;
    } else {
      this.selectedLocation = '';
    }
  }

  showCardholder(cardholder: ProfileSearchResult) {
    CardholderService.storeCardHolder(cardholder);
    this.cardHolderService.storeCardholderResult(cardholder);
    this.router.navigate(['/cardholderProfiles/accounts']);
  }

  submit() {
    this.searchResults = null;
    this.search_btn_spinner = 'fa fa-spinner fa-spin';
    this.search_btn = true;
    this.subview = 'results';
    if (this.firstParameter === undefined || this.firstParameter === '') {
      this.subview = 'noSearchParameters';
      this.search_btn_spinner = '';
      this.search_btn = false;
    } else {
      this.cardHolderService
        .searchCardHolders(this.firstParameter, this.selectedLocation)
        .subscribe(
          data => {
            if (data.length === 0) {
              this.subview = 'noResults';
            } else {
              this.searchResults = data;
              this.subview = 'results';
            }
            this.search_btn_spinner = '';
            this.search_btn = false;
          },
          () => {
            console.log('Error finding cardholders');
          },
          () => {
            this.processing = false;
            const button = document.getElementById('searchButton');
            button.blur();
          }
        );
    }
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }
}
